/**
 * JobMockAI — Top Bar Component
 *
 * Persistent top bar for the App Shell layout.
 * Left: hamburger (mobile).
 * Center: LinkedIn-style primary nav (Home, Network, Jobs, Messaging).
 * Right: notification bell + user avatar dropdown.
 */
import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import NotificationBell from './NotificationBell';
import UserMenu from './UserMenu';
import TopNavLinks from './TopNavLinks';
import TopBarInterviewerLink from './TopBarInterviewerLink';

const TopBar = ({ onToggleSidebar }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Toolbar
        sx={{
          gap: { xs: 0.5, sm: 1 },
          minHeight: { xs: 56, md: 52 },
          px: { xs: 1, sm: 2 },
          overflow: 'hidden',
        }}
      >
        {/* Left: hamburger — mobile only */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: { xs: 40, md: 0 },
            flexShrink: 0,
          }}
        >
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Open navigation menu"
              onClick={onToggleSidebar}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>

        {/* Center: primary destinations */}
        <TopNavLinks />

        {/* Right: Notifications + Me */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, md: 1 },
            flexShrink: 0,
            ml: 0.5,
            pl: 0.5,
            zIndex: 1,
            bgcolor: 'background.paper',
          }}
        >
          <TopBarInterviewerLink />
          <NotificationBell />
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
